import styled, { useTheme } from 'styled-components';

type Props = {
  name: string;
  value: string;
  checked?: boolean;
  size?: number;
  handleChange?: React.ChangeEventHandler<HTMLInputElement>;
  type?: 'radio' | 'checkbox';
};

const ChatRadioButton = ({ name, value, checked = false, size = 20, handleChange, type = 'radio' }: Props) => {
  const theme = useTheme();

  return (
    <>
      <SRadio type={type} name={name} value={value} checked={checked} readOnly onChange={handleChange} />
      <i style={{ width: size, height: size, cursor: 'pointer' }}>
        {checked ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" fill="none">
            <path
              d="M10.7852 1.5C15.7557 1.5 19.7852 5.52944 19.7852 10.5C19.7852 15.4706 15.7557 19.5 10.7852 19.5C5.81459 19.5 1.78516 15.4706 1.78516 10.5C1.78516 5.52944 5.81459 1.5 10.7852 1.5Z"
              stroke={theme.color.line.line_3}
              strokeWidth="2"
            />
            <circle cx="10.7852" cy="10.5" r="6.25" fill={theme.color.static.primary} />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" fill="none">
            <path
              d="M10.7852 1.5C15.7557 1.5 19.7852 5.52944 19.7852 10.5C19.7852 15.4706 15.7557 19.5 10.7852 19.5C5.81459 19.5 1.78516 15.4706 1.78516 10.5C1.78516 5.52944 5.81459 1.5 10.7852 1.5Z"
              stroke={theme.color.line.line_3}
              strokeWidth="2"
            />
          </svg>
        )}
      </i>
    </>
  );
};

export default ChatRadioButton;

const SRadio = styled.input`
  display: none;
`;
